import { grey } from '@mui/material/colors';

export default {
  styleOverrides: {
    contained: {
      color: grey['100'],
      borderRadius: 24,
    },
    sizeSmall: {
      fontSize: '0.705rem'
    },
    outlined: {
      borderRadius: 24,
    },    
  },    
};